import '../../../scss/app/login.scss';

document.getElementById('username').focus();
